import { Component, OnInit, Input } from '@angular/core';
import { localMeasurementDistanceName } from 'src/app/_helpers/extensions.module';
import { Enums } from 'src/app/_models/generatedEnums';
import {  QuickWorkoutDisplayViewModelRead } from 'src/app/_models/generatedModels';

@Component({
  selector: 'quick-workout-view',
  templateUrl: 'quick-workout-view.component.html',
  styleUrls: ['quick-workout-view.component.scss']
})
export class QuickWorkoutViewComponent implements OnInit {
  initialized = false;
  activityTypeEnum = Enums.ActivityTypeEnum;
  localMeasurementName: string;

  @Input()
  quickWorkout: QuickWorkoutDisplayViewModelRead;

  @Input()
  isForPDF: boolean = false;


  constructor() { }

  ngOnInit(): void {
    this.localMeasurementName = localMeasurementDistanceName();
    this.initialized = true;
  }
}
